import ListingContactColleagues from './ListingContactColleagues.component';

export default ListingContactColleagues;
